import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Firefox = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M21.71 9.676v-.003l-.03-.102-.008-.025-.06-.192-.002-.01a10 10 0 0 0-1.022-2.203A10.05 10.05 0 0 0 17.25 3.85a9.95 9.95 0 0 0-6.09-1.388c-1.076.113-2.892.5-4.364 1.794 5.361-2.738 12.524.558 11.914 6.688-.216 2.188-2.074 3.691-3.803 3.945-.307.047-.62.05-.928.009-4.223-.587-3.965-4.049-2.682-5.528-1.696-.011-3.012 2.089-2.373 4.152-1.47-2.732.016-7.01 3.167-8.304-3.703-.536-7.175 1.259-8.29 4.378.133-1.14.399-2.261.792-3.34 0 0-2.019 1.596-2.43 4.952l-.024.21a10 10 0 0 0-.036.471v.037l-.007.199v.055l-.003.237c0 5.523 4.477 10 10 10s9.998-4.477 9.998-10c0-.926-.128-1.848-.382-2.74'
        fill='currentColor'
      />
    ) : (
      <path
        d='M21.71 9.676v-.003l-.03-.102-.008-.025-.06-.192-.002-.01a10 10 0 0 0-1.022-2.203A10.05 10.05 0 0 0 17.25 3.85a9.95 9.95 0 0 0-6.09-1.388c-1.076.113-2.892.5-4.364 1.794 5.361-2.738 12.524.558 11.914 6.688-.216 2.188-2.074 3.691-3.803 3.945-.307.047-.62.05-.928.009-4.223-.587-3.965-4.049-2.682-5.528-1.696-.011-3.012 2.089-2.373 4.152-1.47-2.732.016-7.01 3.167-8.304-3.703-.536-7.175 1.259-8.29 4.378.133-1.14.399-2.261.792-3.34 0 0-2.019 1.596-2.43 4.952l-.024.21a10 10 0 0 0-.036.471v.037l-.007.199v.055l-.003.237c0 5.523 4.477 10 10 10s9.998-4.477 9.998-10c0-.926-.128-1.848-.382-2.74'
        fill='currentColor'
      />
    )}
  </IconBase>
);
